var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-col px-2 lg:flex-row lg:items-center lg:px-0",attrs:{"qaid":"nav-categories-layout"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }